import styled from "styled-components";

const S = {
    Wrapper: styled.section`
        display: flex;
        width: 100%;
        flex-direction: column;
    `,
    Top: styled.div`
        grid-area: headerleft;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 40px 40px;
        align-items: left;
        background-color: #EAEAF6;

        @media (max-width: 648px){
            padding: 20px 16px;
        }
    `,
    Header: styled.h1`
        color: black;
        font-size: 20px;
        margin: 0;

        @media (max-width: 648px){
            font-size: 18px;
        }
    `,
    Span: styled.div`
        color: black;
        font-size: 14px;
        margin: 0;
        text-transform: capitalize;
        opacity: .5;
        a {
            color: black;
            text-decoration: none;
        }
    `,
    Circle: styled.div`
        position: absolute;
        width: 400px;
        height: 400px;
        background: #01aecb;
        border-radius: 100%;
        filter: blur(1.5rem);
        opacity: 0.2;
        top: 300px;
        left: -150px;
    `,
    Section: styled.section`
        margin: 40px;
        grid-area: content;

        @media (max-width: 768px) {
            margin: 20px 14px;
        }

        .banner {
            display: flex;
            flex-direction: row;
            position: relative;
            align-items: center;

            @media (max-width: 768px){
                flex-direction: column;
            }

            .imgwrap {
                position: relative;
                width: 50%;
                height: 300px;

                @media (max-width: 768px){
                    width: 100%;
                    height: 220px;
                }

                .foregroundImg {
                    width: 100%;
                    cursor: pointer;
                    position: relative;
                    z-index: 2;
                    border-radius: 16px;
                    height: 300px;
                    object-fit: cover;

                    @media (max-width: 768px){
                        height: 220px;
                    }
                }

                .backgroundImg {
                    height: 300px;
                    object-fit: cover;
                    width: 100%;
                    position: absolute;
                    top: 2px;
                    left: 0;
                    transform: scale(1.05);
                    transition: all 0.5s ease;
                    opacity: 1;
                    filter: blur(24px);
                    z-index: 1;

                    @media (max-width: 768px){
                        height: 220px;
                    }
                }
            }
            
            .baslik {
                width: 100%;

                @media (max-width: 768px){
                    width: 100%;
                    text-align: center;
                    margin-top: 16px;
                }

                h1 {
                    color: #01aecb;
                    font-size: 3.5em;
                    font-weight: 900;
                    margin: 0px;

                    @media (max-width: 768px){
                        font-size: 2em;
                        width: 100%;
                    }
                }
            }
        }

        h3 {
            color: #01aecb;
            font-size: 2em;

            @media (max-width: 768px) {
                font-size: 1.4em;
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            gap: 20px;

            .TSRM {
                display: flex;
                flex-direction: row;
                gap: 15px;
                height: 300px;

                @media (max-width: 768px) {
                    flex-direction: column;
                    height: auto;
                }

                iframe {
                    width: 350px;
                    border-radius: 12px;
                    border: none;

                    @media (max-width: 768px) {
                        width: 100%;
                        height: 220px;
                    }
                }
            }

            .mapContainer {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                gap: 20px;

                @media (max-width: 768px){
                    grid-template-columns: 1fr;
                }

                iframe {
                    width: 100%;
                    border-radius: 16px;
                    border: none;
                    height: 260px;

                    @media (max-width: 600px) {
                        height: 210px;
                    }
                }
            }

            .texts {
                flex-basis: 50%;

                @media (max-width: 768px) {
                    flex-basis: 100%;
                    font-size: 0.95em;
                    line-height: 1.6;
                }
            }
        }
    `,
    Baslik: styled.h1`
        font-size: 3em;
        text-align: center;

        @media (max-width: 768px) {
            font-size: 2em;
        }
    `,
    Sertifika: styled.div`
        grid-area: headerright;
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding: 0px 40px;
        align-items: center;

        @media (max-width: 648px){
            padding: 20px 16px;
        }

        svg, img {
            margin: 5px;
            width: 50px;
            height: 70px;
            filter: invert(100%);

            @media (max-width: 648px){
                width: 30px;
                height: 30px;
            }
        }
    `,
    Izgara: styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .rowi {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            flex-wrap: wrap;

            @media (max-width: 768px) {
                flex-direction: column;
            }

            &:first-child {
                .items {
                    flex-grow: 1;
                }
            }

            .items {
                margin: 10px;
                padding: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                flex-basis: 20%;

                @media (max-width: 768px) {
                    flex-basis: 100%;
                    width: 100%;
                    box-sizing: border-box;
                    padding: 10px;
                }
                
                img {
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    object-position: top;
                    border-radius: 100%;
                }

                h2 {
                    margin-bottom: 0;
                    color: #01aecb;
                    font-size: 14px;
                }

                .content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    
                    p {
                        margin: 10px 0px;
                        color: #01aecb;
                    }
                }
            }
        }
    `
};

export default S;